module.exports = __webpack_public_path__ + "img/mena-lamp.a16524f0.svg";